import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

/**
 * Protege rotas de negócio: sem token → /login.
 */
const PrivateRoute = () => {
  const { estaAutenticado, carregandoSessao } = useAuth();
  const location = useLocation();

  if (carregandoSessao) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <CircularProgress aria-label="Carregando" />
      </Box>
    );
  }

  if (!estaAutenticado) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
